import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnDestroy,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Subscription } from "rxjs";
import {
  CurrencyCode,
  DataService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";

@Component({
  selector: "single-currency-code-selector",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./single-currency-code-selector.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SingleCurrencyCodeSelectorComponent),
      multi: true,
    },
  ],
})
export class SingleCurrencyCodeSelectorComponent
  implements ControlValueAccessor, OnDestroy
{
  @Input() currencyCodes: string[] = Object.values(CurrencyCode);
  private subscription: Subscription;
  private locale: string;
  protected value: string | undefined = "";
  onChangeFn: (value: string) => void;
  onTouchFn: (value: string) => void;

  @Input()
  readonly = false;

  searchCurrencyCodes = (term: string, item: CurrencyCode) => {
    // const currencyCodeName = new Intl.DisplayNames([this.locale], {
    //   type: "currency",
    // }).of(item);

    // console.log(currencyCodeName);
    // console.log(term);
    // return currencyCodeName?.toLowerCase().includes(term.toLowerCase());

    
    

    return item.toLocaleLowerCase().includes(term.toLowerCase());
  };

  constructor(
    dataService?: DataService,
    changeDetectorRef?: ChangeDetectorRef
  ) {
    if (dataService && changeDetectorRef) {
      this.subscription = dataService.client
        .uiState()
        .mapStream((data) => data.uiState)
        .subscribe(({ language, locale }) => {
          this.locale = language.replace(/_/g, "-");
          if (locale) {
            this.locale += `-${locale}`;
          }
          changeDetectorRef.markForCheck();
        });
    }
  }

  writeValue(obj: string): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchFn = fn;
  }

  trackByFn(item: string) {
    return item;
  }

  compareFunction(item: string, selected: string) {
    return item === selected;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
